import Controller from "./dispatcher.controller";
import template from "./dispatcher.html";

const dispatcher = {
  template,
  controller: Controller,
};

export default dispatcher;



// WEBPACK FOOTER //
// ./src/pages/dispatcher/dispatcher.component.js